import React from "react";
import qrcode from "../../Images/qrcode.jpeg";
import camping from "../../Images/camping.jpg";
import ProductCard from "./ProductCard";
import FAQ from "../Camping/Faq";
import ImageCardsWithVerticalView from "./ImageCardsWithverticalView";

const PackageInfo = ({ data }) => {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center py-8 px-4 sm:px-8 lg:px-12"
      style={{ backgroundImage: `url(${camping})` }}
    >
      <div className="mx-auto max-w-5xl rounded-3xl border border-blue-900/10 bg-slate-50/95 p-5 shadow-2xl sm:p-8 lg:p-10">
        {/* Package Title */}
        <h1 className="mb-5 text-center text-3xl font-bold tracking-tight text-blue-950 sm:text-4xl">
          {data.itinerary?.camping}
        </h1>
        {/* <h1 className="text-3xl font-bold text-center text-blue-600 mb-6 sm:text-4xl lg:text-5xl">
          {data.title}
        </h1> */}
        <p className="mb-5 text-center text-lg font-semibold text-sky-800 sm:text-xl">
          {data.tagline}
        </p>
        <p className="mb-7 text-center text-base leading-7 text-slate-700">
          {data.description}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3 mb-8">
          <a
            href="https://wa.me/9371939191?text=Hi%20SKAdventures%2C%20I%20want%20to%20book%20a%20Pawna%20Lake%20Camping%20stay."
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center rounded-full bg-blue-800 px-5 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-blue-900"
          >
            Book on WhatsApp
          </a>
          <a
            href="tel:9371939191"
            className="inline-flex items-center justify-center rounded-full border border-blue-800 bg-white px-5 py-3 text-sm font-semibold text-blue-900 transition hover:bg-blue-50"
          >
            Call 9371939191
          </a>
        </div>

        {data.heroStats && (
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 mb-10">
            {data.heroStats.map((item, index) => (
              <div
                key={index}
                className="rounded-xl border border-sky-200 bg-gradient-to-r from-sky-50 to-blue-50 p-4 text-center shadow-sm"
              >
                <div className="mb-1 text-xs font-bold uppercase tracking-wide text-blue-800">
                  {item.label}
                </div>
                <div className="text-sm font-semibold text-gray-800">
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        )}

        {data.highlights && (
          <div className="mb-10 rounded-2xl border border-sky-200 bg-sky-50 p-5">
            <h2 className="text-2xl font-bold text-blue-900 mb-4">
              Why guests love this stay
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {data.highlights.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-2 text-gray-800"
                >
                  <span className="mt-1 text-blue-700">✓</span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {data.productData?.map((product, index) => (
            <ProductCard
              key={index}
              title={product.title}
              description={product.description}
              features={product.features}
              images={product.images}
              price={product.price}
              bookingLink={`https://wa.me/9371939191?text=Hi%20SKAdventures%2C%20I%20want%20to%20book%20the%20${encodeURIComponent(product.title)}%20stay%20at%20Pawna%20Lake%20Camping.`}
            />
          ))}
        </div>

        {data.bookingSteps && (
          <div className="mb-10 rounded-2xl border border-sky-200 bg-sky-50 p-5">
            <h2 className="mb-4 text-2xl font-bold text-blue-900">
              Quick booking steps
            </h2>
            <ol className="list-decimal space-y-2 pl-5 text-gray-800">
              {data.bookingSteps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </div>
        )}

        <div>
          {data.verticalCards && (
            <ImageCardsWithVerticalView verticalCards={data.verticalCards} />
          )}
        </div>

        {/* Cost Section */}
        <div className="mb-8 mt-8">
          <h2 className="mb-5 text-2xl font-bold text-stone-900 sm:text-3xl">
            Cost 💰
          </h2>

          <div className="overflow-hidden rounded-3xl border border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 shadow-sm">
            <div className="grid gap-4 p-5 sm:p-6 md:grid-cols-2">
              <div className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-blue-100">
                <p className="text-xs font-bold uppercase tracking-wide text-blue-800">
                  Child (0 to 5 years)
                </p>
                <p className="mt-2 text-lg font-semibold text-gray-900 sm:text-xl">
                  {data.cost.child}
                </p>
              </div>

              <div className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-blue-100">
                <p className="text-xs font-bold uppercase tracking-wide text-blue-800">
                  Child (5 to 11 years)
                </p>
                <p className="mt-2 text-lg font-semibold text-gray-900 sm:text-xl">
                  {data.cost.childDiscounted}
                </p>
              </div>

              <div className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-blue-100 md:col-span-2">
                <p className="text-xs font-bold uppercase tracking-wide text-blue-800">
                  Adult (11 years and above)
                </p>
                <p className="mt-2 text-lg font-semibold text-gray-900 sm:text-xl">
                  {data.cost.adult}
                </p>
              </div>

              <div className="rounded-2xl bg-gradient-to-r from-blue-800 to-blue-600 p-4 text-white shadow-sm md:col-span-2">
                <p className="text-xs font-bold uppercase tracking-wide text-blue-100">
                  Group Discount
                </p>
                <p className="mt-2 text-lg font-semibold sm:text-xl">
                  {data.cost.groupDiscount}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Itinerary Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-800 mb-5 sm:text-3xl">
            Itinerary
          </h2>

          <div className="grid gap-6 lg:grid-cols-2">
            <div className="rounded-3xl border border-sky-200 bg-gradient-to-br from-sky-50 to-blue-50 p-5 shadow-sm sm:p-6">
              <div className="mb-5 flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-blue-800 text-base font-bold text-white shadow-sm">
                  1
                </span>
                <h3 className="text-xl font-semibold text-blue-900 sm:text-2xl">
                  Day 1
                </h3>
              </div>

              <div className="space-y-4">
                {data.itinerary.day1?.map((item, index) => (
                  <div
                    key={index}
                    className="flex gap-3 border-l-2 border-sky-200 pl-3"
                  >
                    <span className="mt-2 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-blue-600" />
                    <div className="flex-1">
                      <p className="text-xs font-semibold uppercase tracking-wide text-blue-800">
                        {item.time}
                      </p>
                      <p className="text-base text-gray-800 sm:text-lg">
                        {item.activity}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-3xl border border-sky-200 bg-gradient-to-br from-sky-50 to-blue-50 p-5 shadow-sm sm:p-6">
              <div className="mb-5 flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-sky-700 text-base font-bold text-white shadow-sm">
                  2
                </span>
                <h3 className="text-xl font-semibold text-blue-900 sm:text-2xl">
                  Day 2
                </h3>
              </div>

              <div className="space-y-4">
                {data.itinerary.day2?.map((item, index) => (
                  <div
                    key={index}
                    className="flex gap-3 border-l-2 border-sky-200 pl-3"
                  >
                    <span className="mt-2 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-sky-600" />
                    <div className="flex-1">
                      <p className="text-xs font-semibold uppercase tracking-wide text-blue-800">
                        {item.time}
                      </p>
                      <p className="text-base text-gray-800 sm:text-lg">
                        {item.activity}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Inclusions and Exclusions Section */}
        <div className="mb-8 grid gap-6 lg:grid-cols-2">
          <div className="rounded-2xl border border-sky-200 bg-sky-50 p-5">
            <h2 className="text-2xl font-semibold text-blue-900 mb-4 sm:text-3xl lg:text-4xl">
              {data.inclusions.title}
            </h2>
            <ul className="list-disc pl-5 space-y-2">
              {data.inclusions.items?.map((item, index) => (
                <li
                  key={index}
                  className="text-gray-800 text-base sm:text-lg lg:text-xl"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-orange-200 bg-orange-50 p-5">
            <h2 className="mb-4 text-2xl font-bold text-orange-900 sm:text-3xl">
              Exclusions ❌
            </h2>
            <ul className="list-disc pl-5 space-y-2">
              {data.exclusions?.map((item, index) => (
                <li
                  key={index}
                  className="text-gray-800 text-base sm:text-lg lg:text-xl"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Food Menu Section */}
        <div className="mb-8 rounded-2xl border border-amber-200 bg-amber-50 p-5">
          <h2 className="text-2xl font-semibold text-amber-700 mb-4 sm:text-3xl lg:text-4xl">
            Food Menu 🥗🍗
          </h2>
          <ul className="list-disc pl-5 space-y-2">
            {data.foodMenu?.map((item, index) => (
              <li
                key={index}
                className="text-gray-800 text-base sm:text-lg lg:text-xl"
              >
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Booking Instructions Section */}
        {/* <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold text-emerald-900 sm:text-3xl">Booking Instructions</h2>
          <ol className="list-decimal list-inside text-gray-700 space-y-3">
            {data.bookingInstructions?.map((instruction, index) => (
              <li key={index} className="mb-2 text-base sm:text-lg lg:text-xl">{instruction}</li>
            ))}
          </ol>
          <div className="flex justify-center mt-6">
            <img
              src={qrcode}
              alt="QR Code"
              className="w-48 h-48 sm:w-56 sm:h-56 lg:w-64 lg:h-64 rounded-md shadow-lg transition-transform transform hover:scale-110"
            />
          </div>
        </div> */}
        <div className="mb-8 rounded-2xl border border-amber-200 bg-amber-50 p-5">
          <h2 className="mb-4 text-2xl font-bold text-emerald-900 sm:text-3xl">
            Booking Instructions
          </h2>
          <ol className="list-decimal space-y-3 pl-5 text-gray-700">
            <li className="text-base sm:text-lg lg:text-xl">
              To secure your reservation, kindly make your payment using the QR
              code below. Please check the beneficiary name as SKAdventures.
            </li>
            <li className="text-base sm:text-lg lg:text-xl">
              After payment, share the screenshot on WhatsApp for confirmation
              and verification.
              <a
                href="https://wa.me/9371939191"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1 font-semibold text-emerald-800 hover:underline"
              >
                Click here to send the screenshot
              </a>
            </li>
            <li className="text-base sm:text-lg lg:text-xl">
              Once confirmed, we will send you the final booking details and a
              quick form to collect your guest preferences, celebration request,
              and arrival time.
            </li>
          </ol>
          <div className="mt-6 flex justify-center">
            <img
              src={qrcode}
              alt="QR Code"
              className="w-48 h-48 rounded-md shadow-lg transition-transform hover:scale-110 sm:w-56 sm:h-56 lg:w-64 lg:h-64"
            />
          </div>
        </div>

        {/* FAQ Section */}
        {data.faq?.length > 0 && (
          <section className="mb-12 rounded-2xl border border-amber-200 bg-gradient-to-br from-amber-50 via-orange-50 to-emerald-50 px-4 py-7 shadow-sm sm:px-7 sm:py-9 lg:px-10">
            <div className="mb-6 sm:mb-8">
              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-emerald-800">
                Need to know more?
              </p>
              <h2 className="text-2xl font-bold tracking-tight text-stone-900 sm:text-3xl lg:text-4xl">
                Frequently Asked Questions
              </h2>
              <p className="mt-2 max-w-2xl text-sm leading-6 text-stone-600 sm:text-base">
                Find helpful details about your stay. Select a question to read
                the answer.
              </p>
            </div>
            <div className="space-y-3">
              {data.faq.map((faq, index) => (
                <FAQ
                  key={index}
                  question={faq.question}
                  answer={faq.answer}
                  index={index}
                />
              ))}
            </div>
          </section>
        )}

        {/* Links Section */}
        <div className="mb-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          <a
            href="/cancellation-policy"
            className="text-sm font-semibold text-emerald-800 underline-offset-4 transition hover:text-emerald-950 hover:underline sm:text-base"
          >
            Cancellation Policy
          </a>
          {data.showCampAdvisory && (
            <a
              href="/camp-advisory"
              className="text-sm font-semibold text-emerald-800 underline-offset-4 transition hover:text-emerald-950 hover:underline sm:text-base"
            >
              Camp Advisory
            </a>
          )}
        </div>

        {/* Additional Text */}
        <div className="mt-6 text-center text-gray-700">
          <p className="text-base sm:text-lg lg:text-xl">
            If you have any questions or require further assistance, please do
            not hesitate to contact us.
          </p>
        </div>

        <div className="mt-4 text-center text-gray-700">
          <p className="text-base sm:text-lg lg:text-xl">
            Don't miss out on this amazing experience!
          </p>
        </div>
      </div>
      {/* Grid layout with responsive columns */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {data.imageUrls?.map((image, index) => (
          <div key={index} className="flex justify-center"> */}
      {/* Image component */}
      {/* <images
              src={image}
              alt={`Image ${index + 1}`}
              className="w-full h-48 sm:h-64 object-cover rounded-lg shadow-md"
            /> */}
      {/* </div>
        ))}
      </div> */}
    </div>
  );
};

export default PackageInfo;
